/* Hand-drawn garden doodles — stroke style, gently animated */

export const Bee = ({ className = "", size = 46 }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={`animate-wiggle ${className}`} aria-hidden="true">
        <path d="M4 40c8-6 16-2 22-8" stroke="#3D3229" strokeWidth="2" strokeLinecap="round" strokeDasharray="1 6" />
        <ellipse cx="30" cy="28" rx="9" ry="7" fill="#F6C544" stroke="#3D3229" strokeWidth="2.2" />
        <path d="M27 21.5v13M33 21.5v13" stroke="#3D3229" strokeWidth="2.2" />
        <circle cx="40" cy="25" r="3.4" fill="#3D3229" />
        <ellipse cx="24" cy="17" rx="5.5" ry="4" fill="#FFF8EC" opacity="0.85" stroke="#3D3229" strokeWidth="1.8" transform="rotate(-24 24 17)" />
        <ellipse cx="34" cy="15" rx="5" ry="3.6" fill="#FFF8EC" opacity="0.85" stroke="#3D3229" strokeWidth="1.8" transform="rotate(-14 34 15)" />
    </svg>
);

export const SunDoodle = ({ className = "", size = 60 }) => (
    <svg width={size} height={size} viewBox="0 0 56 56" fill="none" className={`animate-spin-slow ${className}`} aria-hidden="true">
        {Array.from({ length: 8 }).map((_, i) => (
            <line
                key={i}
                x1="28"
                y1="3"
                x2="28"
                y2="10"
                stroke="#F6C544"
                strokeWidth="3"
                strokeLinecap="round"
                transform={`rotate(${i * 45} 28 28)`}
            />
        ))}
        <circle cx="28" cy="28" r="12" fill="#F6C544" stroke="#3D3229" strokeWidth="2.2" />
        <circle cx="24" cy="26" r="1.6" fill="#3D3229" />
        <circle cx="32" cy="26" r="1.6" fill="#3D3229" />
        <path d="M24 31c2.4 2 5.6 2 8 0" stroke="#3D3229" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

export const Ladybug = ({ className = "", size = 34 }) => (
    <svg width={size} height={size} viewBox="0 0 36 36" fill="none" className={`animate-sway ${className}`} aria-hidden="true">
        <circle cx="18" cy="20" r="11" fill="#E07A5F" stroke="#3D3229" strokeWidth="2.2" />
        <path d="M18 9v22" stroke="#3D3229" strokeWidth="2" />
        <circle cx="13" cy="18" r="1.7" fill="#3D3229" />
        <circle cx="23" cy="18" r="1.7" fill="#3D3229" />
        <circle cx="14" cy="25" r="1.5" fill="#3D3229" />
        <circle cx="22" cy="25" r="1.5" fill="#3D3229" />
        <path d="M12 9a6 6 0 0 1 12 0" fill="#3D3229" />
        <path d="M8 10 5 6M28 10l3-4" stroke="#3D3229" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
);

export const WateringCan = ({ className = "", size = 54 }) => (
    <svg width={size} height={size} viewBox="0 0 56 56" fill="none" className={className} aria-hidden="true">
        <path d="M20 24h16v14a6 6 0 0 1-6 6h-4a6 6 0 0 1-6-6V24z" fill="#E07A5F" stroke="#3D3229" strokeWidth="2.2" />
        <path d="M36 27l10-6 2 4-10 6" fill="#E07A5F" stroke="#3D3229" strokeWidth="2.2" strokeLinejoin="round" />
        <path d="M20 27h-5a6 6 0 0 0 0 12h5" stroke="#3D3229" strokeWidth="2.2" />
        <path d="M46 22l1.4-3M49 25l2.4-2M44.5 19.5l-.4-3.2" stroke="#A8D5E2" strokeWidth="2.2" strokeLinecap="round" />
        <path d="M24 24v-3a4 4 0 0 1 8 0v3" stroke="#3D3229" strokeWidth="2.2" />
    </svg>
);

export const FlowerDoodle = ({ className = "", size = 30, petals = "#E07A5F" }) => (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
        {[0, 72, 144, 216, 288].map((deg) => (
            <ellipse key={deg} cx="16" cy="8" rx="4" ry="5.5" fill={petals} transform={`rotate(${deg} 16 16)`} />
        ))}
        <circle cx="16" cy="16" r="4.4" fill="#F6C544" />
    </svg>
);

export const SproutDoodle = ({ className = "", size = 34 }) => (
    <svg width={size} height={size} viewBox="0 0 36 36" fill="none" className={className} aria-hidden="true">
        <path d="M18 30V16" stroke="#3D3229" strokeWidth="2.6" strokeLinecap="round" />
        <path d="M18 22c-6.5.8-9.6-1.8-10.5-6.4 5.8-1 9.5 1.7 10.5 6.4z" fill="#8FB38A" stroke="#3D3229" strokeWidth="1.8" />
        <path d="M18 19c4.6-3.8 9.2-3.8 12-.8-2.8 3.7-7.4 4.4-12 .8z" fill="#8FB38A" stroke="#3D3229" strokeWidth="1.8" />
        <path d="M13 31c1.6-1.4 8.4-1.4 10 0" stroke="#3D3229" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

export const WavyUnderline = ({ className = "", color = "#F6C544" }) => (
    <svg viewBox="0 0 180 14" fill="none" className={className} aria-hidden="true" preserveAspectRatio="none">
        <path d="M3 10c14-7 27-7 41 0s27 7 41 0 27-7 41 0 27 7 51-2" stroke={color} strokeWidth="6" strokeLinecap="round" />
    </svg>
);
